import axios from "axios";

// Axios Instance
const instance = axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_DEV_BASE_URL,
});

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("adt_access_token");
    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("adt_access_token");
    }
    return Promise.reject(error);
  }
);

export default instance;
